import { SearchInput } from "@design-system/shadcn";
import { cn } from "@design-system/utils";
import React, { type ChangeEvent, type ComponentProps } from "react";

import { useFilters } from "../filters-provider";

interface FilterBarSearchProps extends Omit<
  ComponentProps<typeof SearchInput>,
  "value" | "onChange" | "variant" | "ref"
> {
  name: string;
  placeholder: string;
  "aria-label": string;
  debounceMs: number;
}

function FilterBarSearch({
  name,
  placeholder,
  "aria-label": ariaLabel,
  debounceMs,
  className,
  ...props
}: FilterBarSearchProps) {
  const { getValue, setValue, searchRef } = useFilters();
  const value = getValue(name);

  return (
    <SearchInput
      {...props}
      ref={searchRef}
      variant="pill"
      aria-label={ariaLabel}
      placeholder={placeholder}
      debounceMs={debounceMs}
      className={cn("max-w-70", className)}
      value={typeof value === "string" ? value : ""}
      onChange={(event: ChangeEvent<HTMLInputElement>) =>
        setValue(name, event.target.value)
      }
    />
  );
}

export { FilterBarSearch };
export type { FilterBarSearchProps };
